module.exports = __webpack_public_path__ + "static/media/logoCidepa.4c48e5f7.png";